/** @format */
import { createSlice } from "@reduxjs/toolkit";
import { initialState } from "./state.ts";

const roleSlice = createSlice({
  name: "role",
  initialState,
  reducers: {
    setUserRole(state, action) {
      state.role = action.payload;
    },
  },
});

export const { setUserRole } = roleSlice.actions;
export default roleSlice.reducer;
